import { render, staticRenderFns } from "./models-list.vue?vue&type=template&id=b7a11418"
import script from "./models-list.vue?vue&type=script&lang=js"
export * from "./models-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports